import { createSelector } from 'reselect';

import * as themesSelectors from 'store/themes/selectors';

import { Filter } from './typings';

export const getFilters = createSelector(
    [themesSelectors.getChildThemes],
    (themes): Array<Filter> => themes.map((theme) => ({ filterId: theme.id, filterName: theme.name }))
);
